module.exports = __webpack_public_path__ + "static/media/kingfisher-2046453_640-min.9f3d1fd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kingfisher-2046453_640-min.jpg
// module id = 134
// module chunks = 0